import React from 'react'
import { Redirect, Route, Switch, useLocation } from 'react-router-dom'
import { RoleSysAlertRouting } from '../../../../role/components/role-sys'
import { NoAccess } from '../../../../role/components/no-access'
import { CatalogProvider } from './catalog'
import { RoutesPage } from './routes-page'
import { TargetsPage } from './targets-page'
import { ConnectionsPage } from './connections-page'
import { RunsPage } from './runs-page'
import { SSOCoveragePage } from './sso-coverage-page'
import { RouteEditor } from './route-editor'
import { TargetWorkspace } from './target-workspace'
import { RunDrawer } from './run-drawer'
import { ConnectReturn } from './connect-return'
import { ConnectionWorkspace } from './connection-workspace'
import { pageOfOldAddress } from './paths'
import { PageTrail } from '../../../../shared/sso-workspace/page-trail'
import { SECTION } from '../../../../shared/navigation/sections'

// Each list page's trail is its sidebar entry (audit F7: Alert routing had no
// trail at all); a record's page names itself (workspace-parts.js).
const Trail = ({ section }) => <PageTrail trail={[section]} />

// The old one-page address goes to its page (paths.js pageOfOldAddress).
const OldAddress = () => {
  const { search } = useLocation()
  return <Redirect to={pageOfOldAddress(search)} />
}

// Alert routing's pages (owner 2026-10-30: separate sidebar pages, no tabs;
// paths.js). A route, a target and a connection open as pages of their own,
// in the SSO connection workspace's anatomy; a run opens in its drawer over
// Alert runs, which stays mounted under it.
// SSO alert coverage lives under /admin/sso, beside the other SSO pages, with
// the same permission.
export const LayoutAlertRouting = () =>
  <>
    <Route path="/admin/alert-routing">
      <RoleSysAlertRouting accessRead fallback={<NoAccess what="alert routing" />}>
        <CatalogProvider>
          <Switch>
            <Route exact path="/admin/alert-routing"><OldAddress /></Route>
            <Route path="/admin/alert-routing/routes/:routeID"><RouteEditor /></Route>
            <Route path="/admin/alert-routing/routes"><Trail section={SECTION.alertRoutes} /><RoutesPage /></Route>
            <Route path="/admin/alert-routing/connect/:provider"><ConnectReturn /></Route>
            <Route path="/admin/alert-routing/targets/:targetID"><TargetWorkspace /></Route>
            <Route path="/admin/alert-routing/targets"><Trail section={SECTION.alertTargets} /><TargetsPage /></Route>
            <Route path="/admin/alert-routing/connections/:connectionID"><ConnectionWorkspace /></Route>
            <Route path="/admin/alert-routing/connections"><Trail section={SECTION.alertConnections} /><ConnectionsPage /></Route>
            <Route path="/admin/alert-routing/runs">
              <Trail section={SECTION.alertRuns} />
              <RunsPage />
              <Route path="/admin/alert-routing/runs/:alertID"><RunDrawer /></Route>
            </Route>
            <Route><OldAddress /></Route>
          </Switch>
        </CatalogProvider>
      </RoleSysAlertRouting>
    </Route>
    <Route path="/admin/sso/alert-coverage">
      <RoleSysAlertRouting accessRead fallback={<NoAccess what="SSO alert coverage" />}>
        <Trail section={SECTION.ssoAlertCoverage} />
        <SSOCoveragePage />
      </RoleSysAlertRouting>
    </Route>
  </>
